var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "quest page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg.jpg`)})`
    }
  }, [_vm.luckyBoxInfo.id ? _c('div', {
    staticClass: "quest-main"
  }, [_c('div', {
    staticClass: "tab_main"
  }, _vm._l(_vm.luckyBoxList, function (item, index) {
    return _c('div', {
      staticClass: "tab_item",
      class: [item.status != 1 && 'dis', _vm.selectTab == index ? 'checked' : ''],
      on: {
        "click": function ($event) {
          return _vm.onTap(item, index);
        }
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon
      }
    }) : _vm._e(), item.title == 'TAP' ? [_vm._v(" TAPS ")] : [_vm._v(" " + _vm._s(_vm.$lang(item.title)) + " ")], item.title.toLowerCase() == 'stars' ? _c('div', {
      staticClass: "new",
      style: {
        background: `url(${require(`@images/${_vm.theme}/new/new.png`)}) center/auto 100% no-repeat`
      }
    }) : _vm._e()], 2);
  }), 0), _c('div', {
    staticClass: "box-detail"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "txt"
  }, [_vm._v("Prize Pool")]), _c('i', {
    on: {
      "click": _vm.showTip
    }
  }, [_vm._v("?")])]), _c('div', {
    staticClass: "num"
  }, [_vm.luckyBoxInfo.icon ? _c('img', {
    attrs: {
      "src": _vm.luckyBoxInfo.icon
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.luckyBoxInfo?.round?.buy_amount || 0, 2)) + " / "), _c('span', {
    staticClass: "my-num"
  }, [_vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.luckyBoxInfo?.price * _vm.luckyBoxInfo?.round_duration || 0, 2)) + " ")])]), _c('div', [_c('div', {
    staticClass: "draw-line"
  }, [_c('div', {
    staticClass: "draw-title"
  }, [_c('div', [_vm._v(" 0 " + _vm._s(_vm.luckyBoxInfo.currency == 'TAP' ? 'TAPS' : _vm.luckyBoxInfo.currency) + " ")]), _c('div', [_vm._v(" Draw ")])]), _c('div', {
    staticClass: "draw-line-bg"
  }, [_c('div', {
    staticClass: "draw-line-has",
    style: 'width:' + _vm.hasLength() + '%'
  })])])]), _c('div', {
    staticClass: "draw-no"
  }, [_vm._v(" Draw No." + _vm._s(_vm.luckyBoxInfo?.round?.round_no || 0) + " ")]), _c('div', {
    staticClass: "brief"
  }, [_vm._v(" The box with the fewest purchases will be the winner ")])]), _c('div', {
    staticClass: "box-items",
    class: _vm.luckyBoxInfo.round.status == 2 && 'items-draw'
  }, [_c('div', {
    staticClass: "items"
  }, _vm._l(_vm.luckyBoxInfo.items, function (item, index) {
    return _c('div', {
      staticClass: "item",
      class: [_vm.selectItemIndex == index && 'checked', item.buy_count > 0 && 'checked-1'],
      on: {
        "click": function ($event) {
          _vm.selectItemIndex = index;
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/luckybox/box/${index + 1}${item.buy_count > 0 ? '1' : ''}.png`)
      }
    })]), item.buy_count ? _c('div', {
      staticClass: "bought"
    }, [_c('span', {
      staticClass: "multiply"
    }, [_vm._v("×")]), _vm._v(_vm._s(item.buy_count))]) : _vm._e()]);
  }), 0)]), _c('div', {
    staticClass: "box-balance"
  }, [_c('div', {
    staticClass: "num"
  }, [_c('div', {
    staticClass: "num-balance",
    on: {
      "click": function ($event) {
        return _vm.jumpTo('/wallet');
      }
    }
  }, [_vm._v("Balance "), _vm.luckyBoxInfo.icon ? _c('img', {
    attrs: {
      "src": _vm.luckyBoxInfo.icon
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.luckyBoxInfo.user.assets.balance || 0, 2)) + " ")]), _vm.luckyBoxInfo.title == 'TON' || _vm.luckyBoxInfo.title.toLowerCase() == 'stars' ? _c('div', {
    staticClass: "deposit",
    on: {
      "click": _vm.toDeposit
    }
  }, [_vm._v(" Deposit ")]) : _vm._e()]), _c('div', {
    staticClass: "space"
  }), _vm.luckyBoxInfo.title == 'TON' ? _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "tip-txt",
    on: {
      "click": function ($event) {
        return _vm.jumpTo('/solojack');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/diamond.png`)
    }
  }), _vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.userData.diamond)) + " ")]), _c('i', {
    on: {
      "click": _vm.showDiamondTip
    }
  }, [_vm._v("?")])]) : _vm._e()]), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-1",
    on: {
      "click": function ($event) {
        return _vm.onRanking();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/luckybox/leaderboard.png`)
    }
  }), _c('div', [_vm._v("Leaderboard")])]), _c('div', {
    staticClass: "buy-btn",
    class: _vm.selectItemIndex == -1 || _vm.luckyBoxInfo.round.status != 1 || _vm.luckyBoxInfo.max_buy_count > 0 && _vm.luckyBoxInfo.max_buy_count <= _vm.luckyBoxInfo.user.round.user_buy_count ? 'buy-btn-dis' : '',
    on: {
      "click": function ($event) {
        return _vm.onBuy();
      }
    }
  }, [_c('div', [_vm._v("BUY")]), _c('div', {
    staticClass: "purchase"
  }, [_vm.luckyBoxInfo.icon ? _c('img', {
    attrs: {
      "src": _vm.luckyBoxInfo.icon
    }
  }) : _vm._e(), _c('div', [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.luckyBoxInfo.price || 0, 2)) + " Per Purchase")])])]), _c('div', {
    staticClass: "btn btn-2",
    on: {
      "click": function ($event) {
        return _vm.onRecords();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/luckybox/records.png`)
    }
  }), _c('div', [_vm._v("My Records")])])]), _c('div', {
    staticClass: "solojack-tip",
    on: {
      "click": function ($event) {
        return _vm.jumpTo('/solojack');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/solojack-tip.png`)
    }
  })])]) : _vm._e()]), _c('pop-luckybox-new-round', {
    attrs: {
      "show": _vm.popNewRoundShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popNewRoundShow = $event;
      },
      "accept": _vm.openNew
    }
  }), _c('pop-luckybox-diamond', {
    attrs: {
      "show": _vm.popDiamondShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popDiamondShow = $event;
      }
    }
  }), _c('pop-luckybox-new-tip', {
    attrs: {
      "show": _vm.popTipShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popTipShow = $event;
      }
    }
  }), _c('pop-luckybox-ranking', {
    attrs: {
      "show": _vm.popRankingShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popRankingShow = $event;
      }
    }
  }), _c('pop-luckybox-records', {
    attrs: {
      "show": _vm.popRecordsShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popRecordsShow = $event;
      }
    }
  }), _c('pop-luckybox-records-info', {
    attrs: {
      "show": _vm.popRecordsInfoShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popRecordsInfoShow = $event;
      }
    }
  }), _c('pop-reward-result', {
    attrs: {
      "show": _vm.isPopRewardResultShow,
      "select-row": _vm.selectRow,
      "showBtn": false,
      "title": _vm.$lang('Congratulations on getting')
    },
    on: {
      "update:show": function ($event) {
        _vm.isPopRewardResultShow = $event;
      },
      "accept": _vm.onAccept
    }
  }), _c('pop-star-deposit', {
    attrs: {
      "show": _vm.popStarDepositShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popStarDepositShow = $event;
      },
      "accept": _vm.depositRefresh
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };